import Http from "@/lib/Http";

const path = '/daily/report'

const findLast = () => Http.get(path + "/last", {})

const findById = (id) => Http.get(path, {id})

const findPage = (query, page) => Http.get(path + "/page",
    {title: query.title, page: page.page, size: page.size})

const findSelfPage = (query, page) => Http.get(path + "/self",
    {title: query.title, page: page.number, size: page.size})

const findItems = (id) => Http.get(path + '/items', {id})

const setItemUnused = (id) => Http.post(path + "/item/unuse",{}, {params: {id}})

const setItemSuggest = (id) => Http.post(path + "/item/suggest",{}, {params: {id}})

const setItemContinue = (id) => Http.post(path + "/item/continue",{}, {params: {id}})

const setItemOperaEmpty = (id) => Http.post(path + "/item/operation/to/empty",{}, {params: {id}})

const changeItemConcerned = (id, concernedId) => Http.post(path + "/item/to/concerned",{}, {params: {id, concernedId}})

const findPublicItems = (id) => Http.get(path + "/public/items", {id})

export default {
    findById,
    findPage,
    findLast,
    findSelfPage,
    findItems,
    findPublicItems,
    setItemUnused,
    setItemSuggest,
    setItemContinue,
    setItemOperaEmpty,
    changeItemConcerned
}
